<template>
  <p
    :class="classString"
    :style="cssString"
    @input="updateComponent"
    v-html="html"
    @click="triggerActions"
  ></p>
</template>

<script>
import debounce from "lodash/debounce";
export default {
  name: "paragraph",
  props: {
    text: {
      type: String,
      default: "Empty paragraph"
    },
    grid: {
      type: Object,
      default: () => ({
        backgroundColor: "#fff"
      })
    },
    actions: {
      type: Array
    },
    variables: Object,
    styles: {
      type: Object,
      default: () => {
        return {};
      }
    },
    classes: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      cssString: "",
      classString: ""
    };
  },
  computed: {
    html() {
      let result = this.text;
      if (this.variables) {
        for (const variable in this.variables) {
          const value = this.$store.state.formData[variable];
          result = result.replace(new RegExp(`{${variable}}`, "g"), value);
        }
      }
      return result;
    }
  },
  watch: {
    styles: {
      immediate: true,
      handler() {
        const keys = Object.keys(this.styles);
        const vals = Object.values(this.styles);
        keys.forEach((key, idx) => (this.cssString += key + ":" + vals[idx]));
      }
    },
    classes: {
      immediate: true,
      handler() {
        this.classes.forEach((cls) => {
          this.classString += cls + " ";
        });
      }
    }
  },
  methods: {
    updateComponent: debounce(function (event) {
      this.$emit("component-updated", {
        text: event.target.innerText
      });
    }, 2000),
    triggerActions() {
      if (this.actions) {
        this.actions.forEach((action) => {
          this.$store.dispatch(action, { val: 123 });
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  outline: 0;
  font-family: "Plus Jakarta Sans";
}

@media (max-width: 767px) {
  .removeMarginMobile {
    margin: 0 !important;
  }

  .mobileWrapper {
    padding: 0 !important;
  }
}
</style>